var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageReadAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.795 7.20921C16.0683 7.48816 16.0683 7.94042 15.795 8.21936L7.39497 16.7908C7.12161 17.0697 6.67839 17.0697 6.40503 16.7908L2.20503 12.5051C1.93166 12.2261 1.93166 11.7739 2.20503 11.4949C2.47839 11.216 2.92161 11.216 3.19497 11.4949L6.9 15.2756L14.805 7.20921C15.0784 6.93026 15.5216 6.93026 15.795 7.20921Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.795 7.20921C22.0683 7.48816 22.0683 7.94042 21.795 8.21936L13.395 16.7908C13.1216 17.0697 12.6784 17.0697 12.405 16.7908L11.205 15.5051C10.9317 15.2261 10.9317 14.7739 11.205 14.4949C11.4784 14.216 11.9216 14.216 12.195 14.4949L12.9 15.2756L20.805 7.20921C21.0784 6.93026 21.5216 6.93026 21.795 7.20921Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageReadAll);
export default __webpack_public_path__ + "static/media/message_read_all.a035b674738d07353cf178f55af32bbb.svg";
export { ForwardRef as ReactComponent };